module.exports = __webpack_public_path__ + "static/media/INZ1200.a3af3152.pdf";